import { ButtonBase, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { calculateDaysBetween, chartDateOptions, chartDateTimeFrames, chartRollingUnits, getAllowedTimeframes, normalizeFrame, rollingUnitDays, rollingUnitToFrame } from "../chartFilterEnums";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { DropdownBaseV2 } from "../../../theme/dropdowns/Dropdown";

export const RhTimeframe = ({currentReport,setCurrentReport}) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // 1️⃣ Determine active days (rolling unit span, dynamic range, OR relative)
    const days =
        currentReport?.date.type === chartDateOptions.ROLLING
        ? rollingUnitDays[currentReport?.date.unit]
        : currentReport?.date.type === chartDateOptions.DYNAMIC
        ? calculateDaysBetween(
            currentReport?.date.from,
            currentReport?.date.to
            )
        : currentReport?.date.days;

    // 2️⃣ Allowed frames for ToggleButtonGroup
    const allowedFrames = getAllowedTimeframes(days);

    useEffect(() => {
        const normalized = normalizeFrame(currentReport?.date?.frame, days);

        if (normalized !== currentReport?.date?.frame) {
            setCurrentReport(prev => ({
                ...prev,
                date: {
                    ...prev?.date,
                    frame: normalized,
                },
            }));
        }
    }, [days]);

    return (

        <ToggleButtonGroup
            value={currentReport?.date.frame}
            exclusive
            onChange={(e, value) => {
                if (!value) return;

                setCurrentReport(prev => ({
                    ...prev,
                    date: {
                        ...prev.date,
                        frame: value,
                    },
                }));
            }}

            sx={{
                width:1,
                background:colors.grey[100],
                padding:0.5,
                borderRadius:5,
                transition:"250ms",
                "&.active" : {
                    background: colors.grey[100],
                    transition:"250ms",
                },
                "@media screen and (max-width: 47.9375em)" : {
                    display:"none",
                }
            }}
        >
            {allowedFrames.map(frame => (
                <ToggleButton key={frame} value={frame}
                    sx={{

                        flex:1,
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "24px",
                        textTransform: "unset",
                        borderRadius: "24px !important",
                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 
                        transition: "250ms",
                        "&.Mui-selected": {
                            background: colors.grey[400], 
                            color: "#fff", 
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                        },
                    }}
                >
                    {frame}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    )
}


export const RhTimeframeDropDown = ({currentReport,setCurrentReport}) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // 1️⃣ Determine active days (rolling unit span, dynamic range, OR relative)
    const days =
        currentReport?.date.type === chartDateOptions.ROLLING
        ? rollingUnitDays[currentReport?.date.unit]
        : currentReport?.date.type === chartDateOptions.DYNAMIC
        ? calculateDaysBetween(
            currentReport?.date.from,
            currentReport?.date.to
            )
        : currentReport?.date.days;

    // 2️⃣ Allowed frames for ToggleButtonGroup
    const allowedFrames = getAllowedTimeframes(days);

    useEffect(() => {
        const normalized = normalizeFrame(currentReport?.date?.frame, days);

        if (normalized !== currentReport?.date?.frame) {
            setCurrentReport(prev => ({
                ...prev,
                date: {
                    ...prev?.date,
                    frame: normalized,
                },
            }));
        }
    }, [days]);

    return (
        <DropdownBaseV2
            options={allowedFrames || []}
            selected={allowedFrames?.findIndex?.(item => item === currentReport?.date.frame) ?? -1}
            onChange={(idx) => {

                setCurrentReport(prev => ({
                    ...prev,
                    date: {
                        ...prev.date,
                        frame: allowedFrames[idx],
                    },
                }));
            }}
            closeOnSelection
            disallowDeselection
        >
            {({anchorEl,onClick}) => (
                <ButtonBase
                    onClick={onClick}
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                        height:32,
                        borderRadius:4,
                        px:1.5,
                        minWidth:32,
                        display:"flex",
                        alignItems:'center',
                        justifyContent:"center",
                        fontWeight:"bold",
                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                    }}
                >
                    {currentReport?.date.frame}

                </ButtonBase>
            )}
        </DropdownBaseV2>
        // <ToggleButtonGroup
        //     value={currentReport?.date.frame}
        //     exclusive
        //     onChange={(e, value) => {
        //         if (!value) return;

        //         setCurrentReport(prev => ({
        //             ...prev,
        //             date: {
        //                 ...prev.date,
        //                 frame: value,
        //             },
        //         }));
        //     }}

        //     sx={{
        //         width:1,
        //         background:colors.grey[100],
        //         padding:0.5,
        //         borderRadius:5,
        //         transition:"250ms",
        //         "&.active" : {
        //             background: colors.grey[100],
        //             transition:"250ms",
        //         },
        //         "@media screen and (max-width: 47.9375em)" : {
        //             display:"none",
        //         }
        //     }}
        // >
        //     {allowedFrames.map(frame => (
        //         <ToggleButton key={frame} value={frame}
        //             sx={{

        //                 flex:1,
        //                 padding: 0,
        //                 paddingX: 2,
        //                 border: 0,
        //                 lineHeight: "24px",
        //                 textTransform: "unset",
        //                 borderRadius: "24px !important",
        //                 color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 
        //                 transition: "250ms",
        //                 "&.Mui-selected": {
        //                     background: colors.grey[400], 
        //                     color: "#fff", 
        //                     fontWeight:"bold",
        //                 },
        //                 "&.Mui-selected:hover": {
        //                     background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
        //                 },
        //             }}
        //         >
        //             {frame}
        //         </ToggleButton>
        //     ))}
        // </ToggleButtonGroup>
    )
}


// Rolling-period unit picker (day/week/month/quarter/year). Selecting a unit also seeds its default bucket
// frame; the frame picker then offers the frames allowed for that unit's span.
export const RhRollingUnitDropDown = ({currentReport,setCurrentReport}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const units = Object.values(chartRollingUnits);
    const labels = units.map(u => t(`unit_${u}`));

    return (
        <DropdownBaseV2
            options={labels}
            selected={units.findIndex(u => u === currentReport?.date.unit)}
            onChange={(idx) => {
                const unit = units[idx];
                setCurrentReport(prev => ({
                    ...prev,
                    date: {
                        ...prev.date,
                        unit,
                        frame: rollingUnitToFrame[unit] ?? prev.date.frame,
                    },
                }));
            }}
            closeOnSelection
            disallowDeselection
        >
            {({onClick}) => (
                <ButtonBase
                    onClick={onClick}
                    sx={{
                        flex:1,
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                        height:32,
                        borderRadius:4,
                        px:1.5,
                        minWidth:32,
                        display:"flex",
                        alignItems:'center',
                        justifyContent:"center",
                        fontWeight:"bold",
                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                    }}
                >
                    {t(`unit_${currentReport?.date.unit}`)}
                </ButtonBase>
            )}
        </DropdownBaseV2>
    )
}